<template>
  <div class="main-table-page col-block width-full" :class="[windowType]" :style="{ flex: 1 }">
    <div class="custom-table" :class="{ 'auto-height': autoHeight }">
      <div
        v-if="tableWidths"
        class="table-field col-block grab-container"
        :style="{ width: tableWidths.reduce((s, c) => s + c.value + c.grab, 0) + 'px' }"
      >
        <div v-if="!layout || (layout === 'head')" class="table-container col-block">
          <div class="thead">
            <div class="tr row-block">
              <div
                v-for="(option, index) in tableOptions"
                :key="index"
                class="th row-block"
                :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.value)"
              >
                <span class="ellipsis">{{ option.title }}</span>
                <template v-if="option.sortMap !== null">
                  <div :style="{ width: '5px' }"></div>
                  <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                </template>
                <div
                  v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                  class="grab-box grab-x"
                  :class="{ grabbing: boardData['board1'].grabID === index }"
                  :grab-id="index"
                  :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                  :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                  :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                  :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                ></div>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
        <div v-if="!layout || (layout === 'body')" ref="custom-table-scroll" class="table-group-container col-block width-full">
          <div class="col-block">
            <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
              <div class="tbody">
                <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                  <a class="container-block row-block">
                    <div class="bar"></div>
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                      :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                    >
                      <span
                        :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                        :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                        v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                      ></span>
                      <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                        <div :style="{ width: '5px' }"></div>
                        <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                      </template>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </a>
                </div>
                <div class="tr col-block" :class="{ selectable: false, selected: false }" v-for="(data, dindex) in group.datas" :key="dindex">
                  <a class="container-block row-block stretch" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                    <template v-if="data.type === 'separator'">
                      <div class="bar"></div>
                      <div class="td row-block center" :style="{ flex: 1 }">
                        <span>{{ data.title }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(data[option.value], dindex, data)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template v-if="option.type === 'pdfLink'">
                          <a class="pdf-link link main" @click="e => downloadPDFFile(option.link(data))">(<span>{{ option.linkTitle(data) }}</span>)</a>
                        </template>
                        <template v-else-if="option.type === 'detailInfo'">
                          <div class="info-detail-container container-block col-block flex-start">
                            <div class="info-detail-block row-block">
                              <span v-html="data[defaultTableOptionMap['算定区分'].value]"></span> | 
                              <span>{{ data[defaultTableOptionMap['疾患名'].value] }}</span>
                            </div>
                            <div class="info-detail-block row-block">
                              <span><b>{{ defaultTableOptionMap['税抜価格'].title }}</b> {{ data[defaultTableOptionMap['税抜価格'].value] }}</span> | 
                              <span><b>{{ defaultTableOptionMap['最終更新日'].title }}</b> {{ data[defaultTableOptionMap['最終更新日'].value] }}</span>
                            </div>
                            <div class="info-detail-block row-block">
                              <span><b>PDF</b> <a class="link main" @click="e => downloadPDFFile(defaultTableOptionMap['検査案内書'].link(data))">{{ defaultTableOptionMap['検査案内書'].title }}</a></span> | 
                              <span><a class="link main" @click="e => downloadPDFFile(defaultTableOptionMap['対象遺伝子'].link(data))">{{ defaultTableOptionMap['対象遺伝子'].title }}</a></span> | 
                              <span><a class="link main" @click="e => downloadPDFFile(defaultTableOptionMap['報告書サンプル'].link(data))">{{ defaultTableOptionMap['報告書サンプル'].title }}</a></span>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <span
                            :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                            :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                      <div :style="{ flex: 1 }"></div>
                    </template>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsitive from '@/mixins/responsitiveData.vue'
import pdfDatas from '@/constants/data/pdfDatas.json'
import newPdfDatas from '@/constants/data/newPdfDatas.json'
import { sortData, groupBy } from '@/constants/global/util'

export default {
  mixins: [
    responsitive
  ],
  props: {
    layout: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      sort: {
        disabled: true,
        value: [],
        order: []
      }
    }
  },
  computed: {
    autoHeight () {
      return true
    },
    tableDatas () {
      let tableDatas = [
        {
          type: 'separator',
          title: '2026 年 6 月改定により追加された検査項目'/* ___ */
        },
        ...newPdfDatas,
        {
          type: 'separator',
          title: '2026 年 6 月改定前に収載されている検査項目'/* ___ */
        },
        ...pdfDatas
      ]
      // tableDatas = tableDatas.filter(data => data['疾患名'].includes(this.search))
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      tableDatas = groupBy(tableDatas, () => '_DEFAULT').map(datas => ({ datas: datas }))
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.gSortMap[x]).filter(x => x),
        this.sort.order.filter((_, i) => this.gSortMap[this.sort.value[i]]).map(x => x.replace('-', ''))
      )
      return tableDatas
    },
    sortValue () {
      return this.tableOptions.reduce((s, c) => ({ ...s, [c.value]: c.sortValue || c.value }), {})
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    gSortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.gSortMap || c.gValue } }), {})
    },
    // static
    staticTableWidths () {
      return ['mobile'].includes(this.windowType) ? [
        [
          50
        ],
        [
        ]
      ] : [
        [
          64,
          82,
        ],
        [
          82,
          96,
          96,
          96,
          124
        ]
      ]
    },
    defaultTableOptionMap () {
      const reportDomain = window.origin
      return {
        '点数': {
          title: '点数'/* ___ */,
          value: '点数',
          class: () => ['center'],
          sortMap: null
        },
        '算定区分': {
          title: '算定区分'/* ___ */,
          value: '算定区分',
          class: () => ['center', 'wrap'],
          sortMap: null
        },
        '疾患名': {
          title: '疾患名'/* ___ */,
          value: '疾患名',
          class: () => ['center', 'content-start'],
          sortMap: null
        },
        '税抜価格': {
          title: '税抜価格'/* ___ */,
          value: '税抜価格',
          class: () => ['center', 'content-end'],
          sortMap: null
        },
        '最終更新日': {
          title: '最終更新日'/* ___ */,
          value: '最終更新日',
          class: () => ['center'],
          sortMap: null
        },
        '検査案内書': {
          title: '検査案内書'/* ___ */,
          type: 'pdfLink',
          link: data => ({
            location: 'manual',
            file: data['疾患名'] + '-' + '検査案内書',
            type: 'pdf'
          }),
          linkTitle: data => 'PDF',
          class: () => ['center'],
          sortMap: null
        },
        '対象遺伝子': {
          title: '対象遺伝子'/* ___ */,
          type: 'pdfLink',
          link: data => ({
            location: 'list',
            file: data['疾患名'] + '-' + '対象遺伝子',
            type: ['表現型関連遺伝子包括検査'].includes(data['疾患名']) ? 'xlsx' : 'pdf'
          }),
          linkTitle: data => ['表現型関連遺伝子包括検査'].includes(data['疾患名']) ? 'EXCEL' : 'PDF',
          class: () => ['center'],
          sortMap: null
        },
        '報告書サンプル': {
          title: '報告書サンプル'/* ___ */,
          type: 'pdfLink',
          link: data => ({
            location: 'report',
            file: data['疾患名'] + '-' + '結果報告書見本',
            type: 'pdf'
          }),
          linkTitle: data => 'PDF',
          class: () => ['center'],
          sortMap: null
        }
      }
    },
    exceptionFileType () {
      return {
        '報告書サンプル-表現型関連遺伝子包括検査': 'xlsx'
      }
    },
    tableOptions () {
      return ['mobile'].includes(this.windowType) ? [
        this.defaultTableOptionMap['点数'],
        {
          title: '算定区分 | 疾患名'/* ___ */,
          type: 'detailInfo',
          class: () => [],
          sortMap: null
        }
      ] : [
        '点数',
        '算定区分',
        '疾患名',
        '税抜価格',
        '最終更新日',
        '検査案内書',
        '対象遺伝子',
        '報告書サンプル'
      ].map(key => this.defaultTableOptionMap[key])
    }
  },
  watch: {
    // table
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  methods: {
    downloadPDFFile (linkData) {
      let fileName = [linkData.file, linkData.type].join('.')
      let link = ['', 'pdf', linkData.location, fileName.replace(/ /g, '')].join('/')
      this.$emit('download', link, fileName)
    },
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      let tableWidth = ['mobile'].includes(this.windowType) ? (windowWidth - (10 * 2)) : (1190 - 222)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        1,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    }
  }
}
</script>
